import axios from 'axios';

export const GET_RECEIPTS_URL = '/receipts/getReceipts';
export const DOWNLOAD_RECEIPT = '/receipts/downloadReceiptPDF';
export const CANCEL_RECEIPT = '/receipts/cancelReceipt';
export const GET_RECEIPTS_EXCEL_URL = '/receipts/getReceiptsForExcel';

export function findReceipts(queryParams, cancellationHandlers) {
  return axios.get(GET_RECEIPTS_URL, {params: queryParams, ...cancellationHandlers});
}

export function downloadReceipt(receiptID) {
  return axios.post(DOWNLOAD_RECEIPT, {receiptID});
}

export function cancelReceipt({receiptTypeID, receiptNum}) {
  return axios.post(CANCEL_RECEIPT, {receiptTypeID, receiptNum});
}

export function getReceiptsFile(queryParams) {
  return axios.get(GET_RECEIPTS_EXCEL_URL, {params: queryParams});
}